export default
[
    /*{title: "RechargeBalances.Label.key", dataIndex: "key", key: "key", responsive: ['md']},*/
    /*{title: "RechargeBalances.Label.rechargeId", dataIndex: "rechargeId", key: "rechargeId", responsive: ['md']},*/
    {title: "RechargeBalances.Label.rechageDate", dataIndex: "rechageDate", key: "rechageDate", responsive: ['md']},
    /*{title: "RechargeBalances.Label.companyId", dataIndex: "companyId", key: "companyId", responsive: ['md']},*/
    {title: "RechargeBalances.Label.rechargeAmount", dataIndex: "rechargeAmount", 
    render: value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    parser:value => value!.replace(/\$\s?|(,*)/g, ''),
    key: "rechargeAmount", responsive: ['md']},
    {title: "RechargeBalances.Label.rechargePaymentMethod", dataIndex: "rechargePaymentMethod", key: "rechargePaymentMethod", responsive: ['md']},
    {title: "RechargeBalances.Label.bankName", dataIndex: "bankName", key: "bankName", responsive: ['md']},
    {title: "RechargeBalances.Label.bankTransactionDate", dataIndex: "bankTransactionDate", key: "bankTransactionDate", responsive: ['md']},
    {title: "RechargeBalances.Label.transactionPersonName", dataIndex: "transactionPersonName", key: "transactionPersonName", responsive: ['md']},
    /*{title: "RechargeBalances.Label.rechargeDocumentPhoto", dataIndex: "rechargeDocumentPhoto", key: "rechargeDocumentPhoto", responsive: ['md']},*/
    {title: "RechargeBalances.Label.rechargeRequstConfirmed", dataIndex: "rechargeRequstConfirmed", key: "rechargeRequstConfirmed", responsive: ['md']},

]

